module.exports = __webpack_public_path__ + "static/menu-After School-7a84e05c33bb2889c5386530d0676202.png";